import { of, EMPTY, from, Subject } from 'rxjs';
import * as moment_ from 'moment';
import { config, S3 } from 'aws-sdk';
import { v4 } from 'uuid';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { ɵɵinject, ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, Inject, ɵɵelementStart, ɵɵtext, ɵɵelementEnd, ɵɵnextContext, ɵɵadvance, ɵɵproperty, ɵɵsanitizeUrl, ɵɵtextInterpolate, ɵɵdefineComponent, ɵɵtemplate, ɵɵtemplateRefExtractor, ɵɵelement, ɵɵreference, Component, Input, ɵɵpipe, ɵɵpipeBind4, ɵɵtextInterpolate1, ɵɵdirectiveInject, ɵɵlistener, ɵɵgetCurrentView, ɵɵrestoreView, EventEmitter, ElementRef, ɵɵdefineDirective, Directive, Output, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule } from '@angular/core';
import { tap } from 'rxjs/operators';
import { NgIf, NgForOf, CurrencyPipe, CommonModule } from '@angular/common';
import { RouterLinkWithHref, RouterModule } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA, MatSnackBar } from '@angular/material/snack-bar';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { MatNavList, MatListItem, MatListModule } from '@angular/material/list';
import { MapsAPILoader, AgmCoreModule } from '@agm/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatLine } from '@angular/material/core';

class Dictionary {
    constructor() {
        this.items = {};
        this._count = 0;
    }
    static from(array, field) {
        const dict = new Dictionary();
        array.forEach(value => {
            dict.add(value[field], value);
        });
        return dict;
    }
    containsKey(key) {
        return this.items.hasOwnProperty(key);
    }
    get count() {
        return this._count;
    }
    add(key, value) {
        if (!this.items.hasOwnProperty(key))
            this._count++;
        this.items[key] = value;
    }
    remove(key) {
        const val = this.items[key];
        delete this.items[key];
        this._count--;
        return val;
    }
    item(key) {
        return this.items[key];
    }
    keys() {
        const keySet = [];
        for (const prop in this.items) {
            if (this.items.hasOwnProperty(prop)) {
                keySet.push(prop);
            }
        }
        return keySet;
    }
    values() {
        const values = [];
        for (const prop in this.items) {
            if (this.items.hasOwnProperty(prop)) {
                values.push(this.items[prop]);
            }
        }
        return values;
    }
    clear() {
        this.items = {};
    }
}
class Optional {
    constructor(object) {
        this.wrapped = object;
    }
    static of(object) {
        return new Optional(object);
    }
    static empty() {
        return new Optional(null);
    }
    get value() {
        return this.wrapped;
    }
    get isPresent() {
        return !this.isEmpty;
    }
    get isEmpty() {
        return this.wrapped === null || this.wrapped === undefined;
    }
    /**
     * If the optional value is present, executes the consumer function and returns an observable of the wrapped value
     * If the optional is empty it will return an empty observable, that immediately returns a complete notification
     * @param consumer function that takes a item of type <T> as parameter
     */
    ifPresent(consumer) {
        if (!this.isEmpty) {
            consumer(this.wrapped);
            return of(this.wrapped);
        }
        return EMPTY;
    }
    getOrElse(value) {
        if (this.isEmpty) {
            return value;
        }
        return this.wrapped;
    }
}
function flatMap(input) {
    const output = new Array();
    input.forEach(i => output.push(...i));
    return output;
}
function shallowCompare(a, b, keys) {
    return keys.reduce((equals, key) => equals && a[key] === b[key], true);
}
function distinct(array, arg) {
    if (!arg)
        return Array.from(new Set(array)).map(element => {
            return array.find(s => s === element);
        });
    let key = null;
    let compare = null;
    if (typeof arg === 'function')
        compare = arg;
    else
        key = arg;
    if (key) {
        return Array.from(new Set(array.map(s => s[key]))).map(id => {
            return array.find(s => s[key] === id);
        });
    }
    if (compare) {
        return array.filter((a, i, ar) => {
            return ar.findIndex(b => compare(a, b)) === i;
        });
    }
}
const contain = function (list, val, comparator) {
    return [...list].findIndex(arr_val => comparator(arr_val, val)) > -1;
};
function intersect(a, b) {
    if (Array.isArray(a)) {
        if (a.length === 0) {
            return new Set();
        }
        if (a.length === 1) {
            return new Set([...a[0]]);
        }
        let out = a[0];
        for (let i = 1; i < a.length; i++) {
            out = intersect(out, a[i]);
        }
        return out;
    }
    else {
        return new Set([...a].filter(x => b.has(x)));
    }
}

var Province;
(function (Province) {
    Province["NorthWest"] = "North West";
    Province["Limpopo"] = "Limpopo";
    Province["EasternCape"] = "Eastern Cape";
    Province["FreeState"] = "Free State";
    Province["Gauteng"] = "Gauteng";
    Province["KwaZuluNatal"] = "KwaZulu Natal";
    Province["Mpumalanga"] = "Mpumalanga";
    Province["NorthernCape"] = "Northern Cape";
    Province["WesternCape"] = "Western Cape";
})(Province || (Province = {}));
class Address {
    constructor(line1, line2, city, pocode, province) {
        this.address_1 = line1;
        this.address_2 = line2;
        this.city = city;
        this.province = province;
        this.postal_code = pocode;
    }
    static compare(address1, address2) {
        return shallowCompare(address1, address2, [
            'address_1',
            'address_2',
            'city',
            'municipality',
            'postal_code',
            'province'
        ]);
    }
    equals(other) {
        return shallowCompare(this, other, ['address_1', 'city']);
    }
}
function AddressFromGooglePlaceDetails(details) {
    const componentForm = {
        street_number: 'short_name',
        route: 'long_name',
        locality: 'long_name',
        postal_town: 'long_name',
        neighborhood: 'long_name',
        administrative_area_level_1: 'long_name',
        country: 'long_name',
        postal_code: 'short_name',
        sublocality_level_1: 'long_name'
    };
    const address = details.address_components.reduce((prev, component) => {
        const type = component.types[0];
        if (!componentForm[type])
            return prev;
        const val = component[componentForm[type]];
        return Object.assign(Object.assign({}, prev), { [type]: val });
    }, {});
    let province;
    if (Object.values(Province).includes(address.administrative_area_level_1))
        province = address.administrative_area_level_1;
    return new Address(`${address.street_number ? address.street_number + ' ' : ''}${address.route || ''}`, //line 1
    address.neighborhood || address.sublocality_level_1, //line 2
    address.locality || address.sublocality_level_1 || address.postal_town, //city
    address.postal_code, //postal code
    province //province,
    );
}

const isFileFieldType = function (type) {
    return type !== null && typeof type === 'object' && type.file;
};
const isNumberFieldType = function (type) {
    return type !== null && typeof type === 'object' && type.number;
};
const DEFAULT_CATEGORY = {
    id: 1,
    name: 'General'
};
class ProductCategories extends Dictionary {
    constructor(categories) {
        super();
        categories.forEach(cat => {
            this.add(cat.name, cat);
        });
    }
    getById(id) {
        return this.values().find(cat => cat.id === id);
    }
    getIdByName(name) {
        return this.item(name).id;
    }
}
var FormType;
(function (FormType) {
    FormType["number"] = "number";
    FormType["text"] = "text";
    FormType["select"] = "select";
    FormType["checkbox"] = "checkbox";
    FormType["url"] = "url";
    FormType["upload"] = "upload";
})(FormType || (FormType = {}));
class CategoryDefinition {
    static mapInputType(type) {
        if (isNumberFieldType(type)) {
            return FormType.number;
        }
        if (type === 'text' || type === 'string') {
            return FormType.text;
        }
        if (type === 'url') {
            return FormType.url;
        }
        if (type === 'boolean') {
            return FormType.checkbox;
        }
        if (isFileFieldType(type)) {
            return FormType.upload;
        }
        if (Array.isArray(type) && type.length && type.length > 0) {
            if (type[0] === 'string' || type[0] === 'number')
                return FormType.text;
        }
        return FormType.select;
    }
}

var DeliveryMethod;
(function (DeliveryMethod) {
    DeliveryMethod["Collection"] = "collection";
    DeliveryMethod["Delivery"] = "delivery";
})(DeliveryMethod || (DeliveryMethod = {}));
class OrderSummary {
    constructor(items, delivery_total, delivery_vat) {
        this.items = items;
        this.delivery_total = delivery_total;
        this.delivery_vat = delivery_vat;
    }
    get total_excl_vat() {
        return +this.items.reduce((tot, prod) => (tot += +prod.price * +prod.qty), 0);
    }
    get total_vat() {
        return +this.items.reduce((tot, prod) => (tot += +prod.vat * +prod.qty), 0);
    }
    get total() {
        return this.total_excl_vat + this.total_vat + (this.delivery_total ? +this.delivery_total : 0);
    }
    get delivery_excl_vat() {
        return +this.delivery_total - +this.delivery_vat;
    }
}
var PaymentMethods;
(function (PaymentMethods) {
    PaymentMethods["Ozow"] = "Ozow";
})(PaymentMethods || (PaymentMethods = {}));
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["pending"] = "pending";
    OrderStatus["failed"] = "failed";
    OrderStatus["processing"] = "processing";
    OrderStatus["cancelled"] = "cancelled";
    OrderStatus["onhold"] = "on-hold";
    OrderStatus["collect"] = "collect";
    OrderStatus["completed"] = "completed";
    OrderStatus["refunded"] = "refunded";
})(OrderStatus || (OrderStatus = {}));

const isProductAttribute = function (attribute) {
    return attribute.name !== undefined && attribute.value !== undefined;
};
class ProductUtil {
    static isValid(attribute) {
        if (!attribute)
            return false;
        if (attribute === '')
            return false;
        if (isProductAttribute(attribute) && attribute.value === '')
            return false;
        return true;
    }
    static isUrl(attribute) {
        if (ProductUtil.isValid(attribute) && isProductAttribute(attribute)) {
            return attribute.type === 'url';
        }
        return false;
    }
    static isFile(attribute) {
        if (ProductUtil.isValid(attribute) && isProductAttribute(attribute)) {
            return isFileFieldType(attribute.type);
        }
        return false;
    }
    static isBoolean(attribute) {
        if (ProductUtil.isValid(attribute) && isProductAttribute(attribute)) {
            return attribute.type === 'boolean';
        }
        return false;
    }
    static isOther(attribute) {
        return (ProductUtil.isValid(attribute) &&
            !ProductUtil.isUrl(attribute) &&
            !ProductUtil.isFile(attribute) &&
            !ProductUtil.isBoolean(attribute));
    }
    static getAttribute(product, ix) {
        if (product.attributes && product.attributes.length > 0 && product.fields && product.fields.length > 0) {
            const attribute = product.fields.find(f => f.name === product.attributes[ix]);
            if (ProductUtil.isUrl(attribute) || ProductUtil.isFile(attribute)) {
                return attribute;
            }
            else if (ProductUtil.isBoolean(attribute)) {
                return attribute.name + ': ' + (attribute.value === 'true' ? 'Yes' : 'No');
            }
            else if (ProductUtil.isOther(attribute)) {
                return attribute.name + ': ' + attribute.value;
            }
        }
    }
}
var ProductStatus;
(function (ProductStatus) {
    ProductStatus["publish"] = "publish";
    ProductStatus["draft"] = "draft";
    ProductStatus["pending"] = "pending";
})(ProductStatus || (ProductStatus = {}));
var ProductType;
(function (ProductType) {
    ProductType["classified"] = "Classified";
    ProductType["shop"] = "Shop";
    ProductType["quote"] = "Quote";
})(ProductType || (ProductType = {}));
const DEFAULT_PRODUCT = {
    name: '',
    status: ProductStatus.draft,
    category: DEFAULT_CATEGORY,
    category_id: DEFAULT_CATEGORY.id,
    attributes: ['', ''],
    description: '',
    fields: [],
    product_type: ProductType.shop,
    price: Optional.empty(),
    stock: 0,
    unit_size: 1,
    unit: '',
    order_size: {
        min: 1,
        max: 1
    },
    delivery: Optional.empty(),
    collection_locations: Optional.empty()
};
const getDeliveryMethods = function (product) {
    if (product.delivery_methods) {
        return new Set([...product.delivery_methods]);
    }
    else {
        const delivery_methods = new Set([]);
        if (product.collection_locations.isPresent) {
            delivery_methods.add(DeliveryMethod.Collection);
        }
        if (product.delivery.isPresent) {
            delivery_methods.add(DeliveryMethod.Delivery);
        }
        return delivery_methods;
    }
};
var VatRate;
(function (VatRate) {
    VatRate["Standard"] = "standard";
    VatRate["Zero"] = "zero";
})(VatRate || (VatRate = {}));
const VAT = {
    STANDARD: 0.15,
    ZERO: 0.0
};
const DEFAULT_PRICE = {
    price_excl_vat: 1,
    vat: 0.15,
    vat_rate: VatRate.Standard
};
class ProductSummary {
    constructor(product) {
        this.product = product;
    }
    get collection() {
        if (this.product.collection_locations.isPresent && this.product.collection_locations.value.length === 1) {
            let ret = this.product.collection_locations.value[0].name;
            if (this.product.collection_locations.value[0].province) {
                ret += ' - ' + this.product.collection_locations.value[0].province;
            }
            return ret;
        }
        if (this.product.collection_locations.isPresent && this.product.collection_locations.value.length > 1) {
            return 'Multiple locations';
        }
        return false;
    }
}

const moment = moment_;
var CanonicalDayOfWeek;
(function (CanonicalDayOfWeek) {
    CanonicalDayOfWeek["Mo"] = "Mo";
    CanonicalDayOfWeek["Tu"] = "Tu";
    CanonicalDayOfWeek["We"] = "We";
    CanonicalDayOfWeek["Th"] = "Th";
    CanonicalDayOfWeek["Fr"] = "Fr";
    CanonicalDayOfWeek["Sa"] = "Sa";
    CanonicalDayOfWeek["Su"] = "Su";
})(CanonicalDayOfWeek || (CanonicalDayOfWeek = {}));
class DayOfWeek {
    static getDay(x) {
        if (this.monday.hasOwnProperty(x))
            return CanonicalDayOfWeek.Mo;
        if (this.tuesday.hasOwnProperty(x))
            return CanonicalDayOfWeek.Tu;
        if (this.wednesday.hasOwnProperty(x))
            return CanonicalDayOfWeek.We;
        if (this.thursday.hasOwnProperty(x))
            return CanonicalDayOfWeek.Th;
        if (this.friday.hasOwnProperty(x))
            return CanonicalDayOfWeek.Fr;
        if (this.saturday.hasOwnProperty(x))
            return CanonicalDayOfWeek.Sa;
        if (this.sunday.hasOwnProperty(x))
            return CanonicalDayOfWeek.Su;
        throw new Error('Cannot parse day of week');
    }
}
DayOfWeek.monday = {
    MON: '',
    MO: '',
    MAAN: '',
    MA: '',
    M: '',
    MONDAY: '',
    MAANDAG: ''
};
DayOfWeek.tuesday = {
    TU: '',
    TUE: '',
    TUES: '',
    TUESDAY: '',
    DI: '',
    DINS: '',
    DIN: '',
    DINSDAG: ''
};
DayOfWeek.wednesday = {
    WE: '',
    WED: '',
    WEDNESDAY: '',
    WO: '',
    WOENS: '',
    WOENSDAG: ''
};
DayOfWeek.thursday = {
    TH: '',
    THU: '',
    THURSDAY: '',
    DO: '',
    DON: '',
    DONDERDAG: ''
};
DayOfWeek.friday = {
    FR: '',
    FRI: '',
    FRIDAY: '',
    VR: '',
    VRY: '',
    VRYDAG: ''
};
DayOfWeek.saturday = {
    SA: '',
    SAT: '',
    SATURDAY: '',
    SATERDAG: ''
};
DayOfWeek.sunday = {
    SU: '',
    SUN: '',
    SUNDAY: '',
    SON: '',
    SO: '',
    SONDAG: ''
};
class DayTimeParser {
    static parseHours(hourString) {
        if (hourString.indexOf('-') > 0 || hourString.indexOf(' ') > 0) {
            const splitter = hourString.indexOf('-') > 0 ? '-' : ' ';
            const tmp = hourString.split(splitter);
            const startStr = tmp[0].trim();
            const endStr = tmp[1].trim();
            const start = DayTimeParser.parseHour(startStr);
            const end = DayTimeParser.parseHour(endStr);
            return {
                open: start,
                close: end
            };
        }
        throw new Error("No valid separator ('-'/' ') found between open and closing hours.");
    }
    static parseHour(hourString) {
        const h = moment(hourString, ['h:m a', 'H:m']);
        const hour = h.format('HH:mm');
        return hour;
    }
    static matchDayOfWeek(dayString) {
        return DayOfWeek.getDay(dayString.toUpperCase());
    }
    static parseDaysOfWeek(daysString) {
        // split on separator '-', ' - ' or ' '
        if (daysString.indexOf('-') > 0 || daysString.indexOf(' ') > 0) {
            const splitter = daysString.indexOf('-') > 0 ? '-' : ' ';
            const tmp = daysString.split(splitter);
            return [this.matchDayOfWeek(tmp[0].trim()), this.matchDayOfWeek(tmp[1].trim())];
        }
        else {
            // single day
            return [this.matchDayOfWeek(daysString)];
        }
    }
}
class OperatingHours {
    constructor(hourString) {
        // spit on new lines and then split on first  ':'
        this.parse(hourString);
    }
    static hoursToString(hours) {
        const oh = new OperatingHours('');
        oh.hours = hours;
        return oh.toString();
    }
    static parse(hourStr) {
        return new OperatingHours(hourStr).hours;
    }
    parse(str) {
        this.hours = new Array();
        if (str && str !== '') {
            this.hours = new Array();
            const rows = str.trim().split('\n');
            for (const r of rows) {
                const temp = r.split(': ');
                const days = DayTimeParser.parseDaysOfWeek(temp[0].trim());
                const hours = temp[1];
                const hrs = DayTimeParser.parseHours(hours);
                this.hours.push({
                    start_day: days[0],
                    end_day: days[1],
                    start_time: hrs.open,
                    end_time: hrs.close
                });
            }
        }
    }
    toString() {
        const out = new Array();
        for (const h of this.hours) {
            const dowEnd = h.end_day ? h.end_day : '';
            const temp = h.start_day + ' - ' + dowEnd + ': ' + h.start_time + ' - ' + h.end_time;
            out.push(temp);
        }
        return out.join('\n');
    }
}

class CollectionLocation {
    constructor() {
        this.clear();
    }
    clear() {
        this.id = null;
        this.name = '';
        this.address = new Address('', '', '');
        this.description = '';
        this.hours = new OperatingHours('').hours;
        this.geo_location = {
            longitude: 25,
            latitude: -30
        };
    }
}
class CollectionLocationUtil {
    static toSummary(location) {
        return {
            id: location.id,
            name: location.name,
            province: location.address.province
        };
    }
}

var DeliveryFeeOption;
(function (DeliveryFeeOption) {
    DeliveryFeeOption["order"] = "order";
    DeliveryFeeOption["batch"] = "batch";
})(DeliveryFeeOption || (DeliveryFeeOption = {}));
class DeliveryRates {
    constructor(rates) {
        this._rates = new Dictionary();
        if (rates) {
            for (const r of rates) {
                this.addRate(r);
            }
        }
    }
    addRate(rate) {
        // only add unique rates
        if (this._rates.containsKey('All')) {
            return false;
        }
        if (this._rates.count > 0 && rate.province === 'All') {
            return false;
        }
        if (this._rates.containsKey(rate.province)) {
            const munis = this._rates.item(rate.province);
            if (munis.count > 0 && rate.municipality === 'All') {
                return false;
            }
            if (munis.containsKey('All')) {
                return false;
            }
            if (munis.containsKey(rate.municipality)) {
                return false;
            }
            munis.add(rate.municipality, rate);
            this._rates.add(rate.province, munis);
            return true;
        }
        const muni = new Dictionary();
        muni.add(rate.municipality, rate);
        this._rates.add(rate.province, muni);
        return true;
    }
    deleteRate(rate) {
        // remove rates from array
        if (this._rates.item(rate.province).count > 1) {
            return this._rates.item(rate.province).remove(rate.municipality);
        }
        return this._rates.remove(rate.province).values()[0];
    }
    get rates() {
        if (this._rates.count > 0) {
            const val = this._rates.values().map(dict => dict.values());
            return flatMap(val);
        }
        return [];
    }
}
class DeliveryDetails {
    constructor(deliveryTime) {
        this.delivery_time_days = deliveryTime;
        this.order_or_batch = DeliveryFeeOption.order;
        this._rates = new DeliveryRates();
    }
    static from(details) {
        const delivery = new DeliveryDetails(details.delivery_time_days);
        delivery.order_or_batch = details.order_or_batch;
        if (details.rates && Array.isArray(details.rates)) {
            const rates = new DeliveryRates(details.rates);
            delivery._rates = rates;
        }
        return delivery;
    }
    get rates() {
        return this._rates.rates;
    }
    set rates(rates) {
        this._rates = new DeliveryRates(rates);
    }
    get data() {
        return {
            delivery_time_days: this.delivery_time_days,
            order_or_batch: this.order_or_batch,
            rates: this.rates
        };
    }
}
const DEFAULT_DELIVERY = new DeliveryDetails(5);
function deliveryOverlap(rate, list) {
    if (list.size === 0)
        return true;
    if (list.size > 0 && rate.province === 'All')
        return true;
    return contain(list, rate, (list_rate, r2) => {
        return rateOverlap(list_rate, r2);
    });
}
function rateOverlap(rate1, rate2) {
    if (rate1.province === 'All')
        return true;
    if (rate1.province === rate2.province && (rate1.municipality === 'All' || rate2.municipality === 'All'))
        return true;
    if (rate1.province === rate2.province && rate1.municipality === rate2.municipality)
        return true;
    return false;
}

var Bank;
(function (Bank) {
    Bank["FNB"] = "FNB";
    Bank["Capitec"] = "Capitec";
    Bank["Standard"] = "Standard Bank";
    Bank["Investec"] = "Investec";
    Bank["Nedbank"] = "Nedbank";
})(Bank || (Bank = {}));
var AccountStatus;
(function (AccountStatus) {
    AccountStatus["active"] = "Active";
    AccountStatus["pending"] = "Pending";
    AccountStatus["declined"] = "Declined";
})(AccountStatus || (AccountStatus = {}));
var Roles;
(function (Roles) {
    Roles["merchant"] = "merchant";
    Roles["pending_merchant"] = "pending_merchant";
    Roles["customer"] = "customer";
})(Roles || (Roles = {}));
const isDeliveryAddressProfile = (profile) => {
    return profile.geo_location !== undefined;
};
const isBillingProfile = (profile) => {
    return profile.vat_no !== undefined;
};

class S3Uploader {
    constructor(aws_config, file_suffix) {
        config.update(aws_config);
        this.bucket = aws_config.s3_bucket;
        this.s3 = new S3({
            apiVersion: '2006-03-01',
            params: { Bucket: aws_config.s3_bucket }
        });
        this.file_extension = file_suffix;
    }
    upload(file, content, prefix = '') {
        const ext = this.file_extension ? this.file_extension : '';
        const id = v4();
        let fileKey = id + ext;
        if (prefix) {
            const path_key = prefix + '/';
            fileKey = path_key + id + ext;
        }
        // Use S3 ManagedUpload class as it supports multipart uploads
        const upload = new S3.ManagedUpload({
            params: {
                Bucket: this.bucket,
                Key: fileKey,
                Body: content
            }
        });
        return from(upload.promise().then(_ => {
            console.log('Successfully uploaded file.');
            return fileKey;
        }, err => {
            console.log('There was an error uploading the file: ', err.message);
            return false;
        }));
    }
    createFolder(name) {
        name = name.trim();
        const f_key = encodeURIComponent(name) + '/';
        this.s3.headObject({ Key: f_key, Bucket: this.bucket }, (err, _) => {
            if (!err) {
                console.log('Folder already exists.');
            }
            if (err.code !== 'NotFound') {
                console.log('There was an error creating the folder: ' + err.message);
            }
            this.s3.putObject({ Key: f_key, Bucket: this.bucket }, (e, data) => {
                if (e) {
                    console.log('There was an error creating the folder: ' + e.message);
                }
                console.log('Successfully created folder.');
            });
        });
    }
}

const ERROR = {
    REQUIRED: 'This field is required',
    REQUIRED_LOCATION_NAME: 'Please supply a name for the location',
    REQUIRED_CITY: 'Please add the City',
    REQUIRED_PROVINCE: 'Please choose a province',
    REQUIRED_OPERATING_HOURS: 'Please provide the Operating Hours',
    REQUIRED_VAT_RATE: 'Please select a VAT Rate',
    REQUIRED_PRODUCT_NAME: 'Please supply a product name',
    REQUIRED_PRODUCT_DESCRIPTION: 'Please supply a product description',
    REQUIRED_EMAIL: 'Email is required.',
    REQUIRED_PASSWORD: 'Password is required.',
    REQUIRED_CURRENT_PASSWORD: 'The current password is required',
    SHORT_PRODUCT_NAME: 'Please supply a product name that is at least 4 characters long',
    SHORT_PASSWORD: 'Your password needs to be at least 6 characters long',
    NON_ZERO_PRICE_REQUIRED: 'A non-zero price is required',
    INVALID_OPERATING_HOURS: 'Invalid Operating Hour format',
    INVALID_EMAIL: 'Please enter a valid email address',
    MINIMUM_BATCH_SIZE: 'Minimum batch size of one unit is required',
    MIN_MAX_ORDER_SIZE: 'The minimum and maximum order size should be a multiple of the batch size and the max should be equal or larger than the min.',
    NON_MATCHING_PASSWORDS: "Your passwords don't match",
    UNACCEPTED_TERMS: 'Please accept the Terms and Conditions',
    INVALID_TEL: 'Please enter a valid phone number',
    USER_EXISTS: 'The user already exists',
    REGISTRATION_ERROR: 'Something happened and you were not registered',
    INVALID_URL: 'Invalid URL',
    MINIMUM_STOCK: 'Please specify an amount greater than 0',
    POSITIVE_NUMBER_REQUIRED: 'A positive number is required',
    INVALID_NUMBER: 'A valid number is required',
    WHOLE_NUMBER_REQUIRED: 'A whole number is required',
    LOGIN_ERROR: 'Something happened and you have not been signed in',
    USERNAME_PASSWORD_ERROR: 'The username or password is incorrect',
    OUT_OF_STOCK: 'This product is currently out of stock',
    DIFFERENT_MERCHANT: 'You can only checkout products from one merchant at a time',
    DIFFERENT_DELIVERY_METHOD: 'Only products with the same delivery method can be added to your cart',
    DIFFERENT_RATES_AND_COLLECTION_LOCATION: 'Only products with matching delivery or collection requirements can be added to your cart'
};
const NOTIFICATION = {
    PRODUCT_LOCATIONS_NOT_UPDATED: 'The location will not be updated on products that already exist. Please edit each product available at this collection location and select the updated location to reflect the changes.',
    PRODUCT_CONFIRM_UNPUBLISH: 'Your product will be removed from the shop and will be subject to approval before being published again.',
    PRODUCT_PUBLISHED: 'Your product is now in review and will be published once approved.',
    PRODUCT_UNPUBLISHED: 'Your product has successfully been unpublished and will no longer be visible in the shop.',
    PRODUCT_CREATED: 'You have added a draft product. Publish the product to make it available in the shop.'
};

var AlertType;
(function (AlertType) {
    AlertType["info"] = "info";
    AlertType["warning"] = "warning";
    AlertType["danger"] = "danger";
})(AlertType || (AlertType = {}));
class Alert {
    constructor(type, message) {
        this.type = type;
        this.message = message;
        this.showAlert = true;
    }
}

var Context;
(function (Context) {
    Context["embed"] = "embed";
    Context["view"] = "view";
    Context["edit"] = "edit";
})(Context || (Context = {}));
var Namespace;
(function (Namespace) {
    Namespace["wp"] = "/wp/v2";
    Namespace["ac"] = "/agrichecker/v1";
    Namespace["jwt"] = "/jwt-auth/v1";
})(Namespace || (Namespace = {}));
var Endpoints;
(function (Endpoints) {
    Endpoints["signin"] = "/token";
    Endpoints["forgot_password"] = "/forgot_password";
    Endpoints["update_password"] = "/update_password";
    Endpoints["validate_token"] = "/token/validate";
    Endpoints["customer_orders"] = "/customer/orders";
    Endpoints["retry_payment"] = "/customer/orders/retry_payment";
    Endpoints["municipalities"] = "/municipalities";
    Endpoints["merchant_orders"] = "/merchant/orders";
    Endpoints["analytics"] = "/merchant/order_analytics";
    Endpoints["commissions"] = "/merchant/commissions";
    Endpoints["merchant_profile"] = "/merchant/profile";
    Endpoints["merchant_billing"] = "/merchant/billing";
    Endpoints["merchant_contacts"] = "/merchant/contacts";
    Endpoints["customer_profile"] = "/customer/profile";
    Endpoints["merchant_locations"] = "/merchant/locations";
    Endpoints["customer_me"] = "/customer/me";
    Endpoints["customer_registration"] = "/customer_register";
    Endpoints["merchant_registration"] = "/merchant_register";
    Endpoints["products"] = "/products";
    Endpoints["product_options"] = "/product_options";
    Endpoints["categories"] = "/products/categories";
    Endpoints["contact_us"] = "/contactus";
    Endpoints["request_quote"] = "/merchant/quote";
    Endpoints["media"] = "/media";
})(Endpoints || (Endpoints = {}));
class ApiService {
    constructor(http, api_url) {
        this.http = http;
        this.api_url = api_url;
    }
    buildRequestUrl(namespace, endpoint) {
        return this.api_url + namespace + endpoint;
    }
    buildHeaders() {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            Accept: 'application/json'
        });
    }
    prepareQueryParams(params) {
        const parms = params ? JSON.parse(JSON.stringify(params)) : {};
        Object.keys(parms).forEach(key => {
            if (Array.isArray(params[key])) {
                parms[key + '[]'] = parms[key];
                delete parms[key];
            }
        });
        return parms;
    }
    /**
     *
     * @param namespace API namespace
     * @param endpoint API endpoint
     */
    get(namespace, endpoint, params) {
        params = this.prepareQueryParams(params);
        return this.http.get(this.buildRequestUrl(namespace, endpoint), {
            params: params,
            headers: this.buildHeaders()
        });
    }
    /**
     *
     * @param namespace API namespace
     * @param endpoint API endpoint
     * @param context view or edit (default: view)
     * @param body Http request body (optional)
     */
    post(namespace, endpoint, body) {
        return this.http.post(this.buildRequestUrl(namespace, endpoint), body, {
            headers: this.buildHeaders()
        });
    }
    put(namespace, endpoint, body, context = Context.view) {
        const ctxObj = { context: context };
        return this.http.put(this.buildRequestUrl(namespace, endpoint), body, {
            params: ctxObj,
            headers: this.buildHeaders()
        });
    }
    delete(namespace, endpoint, params) {
        return this.http.delete(this.buildRequestUrl(namespace, endpoint), {
            params: params,
            headers: this.buildHeaders()
        });
    }
}
ApiService.ɵfac = function ApiService_Factory(t) { return new (t || ApiService)(ɵɵinject(HttpClient), ɵɵinject('api_url')); };
ApiService.ɵprov = ɵɵdefineInjectable({ token: ApiService, factory: ApiService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ApiService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['api_url']
            }] }]; }, null); })();

class CityLookupService {
    constructor(api) {
        this.api = api;
        this._municipalities = new Dictionary();
    }
    getMunicipalitiesInProvince(province) {
        return this._municipalities.containsKey(province)
            ? of(this._municipalities.item(province))
            : this.api
                .get(Namespace.ac, '/municipalities', {
                province: province
            })
                .pipe(tap(municipalities => {
                this._municipalities.add(province, municipalities);
            }));
    }
    getCitiesInProvince(province) { }
}
CityLookupService.PROVINCES = Object.values(Province);
CityLookupService.ɵfac = function CityLookupService_Factory(t) { return new (t || CityLookupService)(ɵɵinject(ApiService)); };
CityLookupService.ɵprov = ɵɵdefineInjectable({ token: CityLookupService, factory: CityLookupService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CityLookupService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiService }]; }, null); })();

var ResizeMode;
(function (ResizeMode) {
    ResizeMode[ResizeMode["disabled"] = 0] = "disabled";
    ResizeMode["cover"] = "cover";
    ResizeMode["contain"] = "contain";
    ResizeMode["fill"] = "fill";
    ResizeMode["inside"] = "inside";
    ResizeMode["outside"] = "outside";
})(ResizeMode || (ResizeMode = {}));
var ImageSize;
(function (ImageSize) {
    ImageSize[ImageSize["thumbnail"] = 0] = "thumbnail";
    ImageSize[ImageSize["small"] = 1] = "small";
    ImageSize[ImageSize["medium"] = 2] = "medium";
    ImageSize[ImageSize["large"] = 3] = "large";
})(ImageSize || (ImageSize = {}));
class ImageService {
    constructor(config) {
        this.config = config;
        this.apiEndpoint = 'https://cdn.agrichecker.com';
        this.bucketName = 'cdn.dev.agrichecker.com';
        if (config.url) {
            this.apiEndpoint = this.config.url;
        }
        this.bucketName = this.config.bucket;
    }
    getImage(image_id, size) {
        const img_size = this.imageSizer(size);
        const config = {
            width: img_size.width,
            height: img_size.height,
            resize: ResizeMode.contain,
            fillColor: '#FFFFFF'
        };
        return this.getImageTransform(config, image_id);
    }
    imageSizer(size) {
        let w = 200;
        let h = 200;
        if (size === ImageSize.thumbnail) {
            w = h = 32;
        }
        if (size === ImageSize.small) {
            w = h = 120;
        }
        if (size === ImageSize.medium) {
            w = h = 360;
        }
        if (size === ImageSize.large) {
            w = h = 640;
        }
        return {
            width: w,
            height: h
        };
    }
    getOriginal(key) {
        // Gather the bucket name and image key
        const keyName = key;
        // Assemble the image request
        const request = {
            bucket: this.bucketName,
            key: keyName
        };
        const strRequest = JSON.stringify(request);
        const encRequest = btoa(strRequest);
        return `${this.apiEndpoint}/${encRequest}`;
    }
    getImageTransform(config, name) {
        // Setup the edits object
        const _edits = {};
        _edits.resize = {};
        if (config.resize !== ResizeMode.disabled) {
            if (config.width && config.width !== 0) {
                _edits.resize.width = +config.width;
            }
            if (config.height && config.height !== 0) {
                _edits.resize.height = +config.height;
            }
            _edits.resize.fit = config.resize.toString();
        }
        if (config.fillColor && config.fillColor !== '') {
            _edits.resize.background = this.hexToRgbA(config.fillColor, 1);
        }
        if (config.backgroundColor && config.backgroundColor !== '') {
            _edits.flatten = { background: this.hexToRgbA(config.backgroundColor, undefined) };
        }
        if (config.grayscale) {
            _edits.grayscale = config.grayscale;
        }
        if (config.flip) {
            _edits.flip = config.flip;
        }
        if (config.flop) {
            _edits.flop = config.flop;
        }
        if (config.negative) {
            _edits.negate = config.negative;
        }
        if (config.flatten) {
            _edits.flatten = config.flatten;
        }
        if (config.normalize) {
            _edits.normalise = config.normalize;
        }
        if (config.rgb && config.rgb !== '') {
            const input = config.rgb.replace(/\s+/g, '');
            const arr = input.split(',');
            const rgb = { r: Number(arr[0]), g: Number(arr[1]), b: Number(arr[2]) };
            _edits.tint = rgb;
        }
        if (config.smartCrop) {
            _edits.smartCrop = {};
            if (config.smartCropIndex && config.smartCropIndex !== 0) {
                _edits.smartCrop.faceIndex = +config.smartCropIndex;
            }
            if (config.smartCropPadding && config.smartCropPadding !== 0) {
                _edits.smartCrop.padding = Number(config.smartCropPadding);
            }
        }
        if (Object.keys(_edits.resize).length === 0) {
            delete _edits.resize;
        }
        // Gather the bucket and key names
        const bucketName = this.bucketName;
        const keyName = name;
        // Set up the request body
        const request = {
            bucket: bucketName,
            key: keyName,
            edits: _edits
        };
        if (Object.keys(request.edits).length === 0) {
            delete request.edits;
        }
        // Setup encoded request
        const str = JSON.stringify(request);
        const enc = btoa(str);
        // Fill the preview image
        return `${this.apiEndpoint}/${enc}`;
    }
    hexToRgbA(hex, _alpha) {
        let c;
        if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
            c = hex.substring(1).split('');
            if (c.length === 3) {
                c = [c[0], c[0], c[1], c[1], c[2], c[2]];
            }
            c = '0x' + c.join('');
            // tslint:disable-next-line: no-bitwise
            return { r: (c >> 16) & 255, g: (c >> 8) & 255, b: c & 255, alpha: Number(_alpha) };
        }
        throw new Error('Bad Hex');
    }
}
ImageService.ɵfac = function ImageService_Factory(t) { return new (t || ImageService)(ɵɵinject('cdn_config')); };
ImageService.ɵprov = ɵɵdefineInjectable({ token: ImageService, factory: ImageService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ImageService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['cdn_config']
            }] }]; }, null); })();

function FooterComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "a", 9);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("href", ctx_r0.links.what_is_agrichecker.url, ɵɵsanitizeUrl);
    ɵɵadvance(1);
    ɵɵtextInterpolate(ctx_r0.links.what_is_agrichecker.title);
} }
function FooterComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "a", 31);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵproperty("routerLink", ctx_r2.links.what_is_agrichecker.url);
    ɵɵadvance(1);
    ɵɵtextInterpolate(ctx_r2.links.what_is_agrichecker.title);
} }
function FooterComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "a", 32);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("href", ctx_r3.links.advertise.url, ɵɵsanitizeUrl);
    ɵɵadvance(1);
    ɵɵtextInterpolate(ctx_r3.links.advertise.title);
} }
function FooterComponent_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "a", 31);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵɵnextContext();
    ɵɵproperty("routerLink", ctx_r5.links.advertise.url);
    ɵɵadvance(1);
    ɵɵtextInterpolate(ctx_r5.links.advertise.title);
} }
function FooterComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "a", 32);
    ɵɵtext(2, "Contact us");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("href", ctx_r6.links.contact_us.url, ɵɵsanitizeUrl);
} }
function FooterComponent_ng_template_20_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "a", 31);
    ɵɵtext(1, "Contact us");
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵɵnextContext();
    ɵɵproperty("routerLink", ctx_r8.links.contact_us.url);
} }
function FooterComponent_div_23_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "a", 32);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("href", ctx_r9.links.register.url, ɵɵsanitizeUrl);
    ɵɵadvance(1);
    ɵɵtextInterpolate(ctx_r9.links.register.title);
} }
function FooterComponent_ng_template_24_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "a", 31);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵɵnextContext();
    ɵɵproperty("routerLink", ctx_r11.links.register.url);
    ɵɵadvance(1);
    ɵɵtextInterpolate(ctx_r11.links.register.title);
} }
class FooterComponent {
    constructor() { }
    ngOnInit() { }
}
FooterComponent.ɵfac = function FooterComponent_Factory(t) { return new (t || FooterComponent)(); };
FooterComponent.ɵcmp = ɵɵdefineComponent({ type: FooterComponent, selectors: [["acx-footer"]], inputs: { links: "links" }, decls: 45, vars: 10, consts: [[1, "mt-2"], [1, "navbar", "navbar-dark", "bg-dark"], [1, "container"], [1, "navbar-expand", "navbar-text"], [1, "row"], [1, "col-md-6", "mx-auto"], [4, "ngIf", "ngIfElse"], ["local_what", ""], ["local_advertise", ""], ["target", "_blank", 3, "href"], ["local_contact", ""], ["local_register", ""], [1, "row", "mt-3"], ["href", "https://facebook.com/agrichecker", "target", "_blank", "rel", "noopener", 1, "nav-item", "nav-link"], ["src", "assets/img/facebook.icon.svg", 2, "height", "30px"], ["href", "https://twitter.com/agrichecker", "target", "_blank", "rel", "noopener", 1, "nav-item", "nav-link"], ["src", "assets/img/twitter.icon.svg", 2, "height", "30px"], ["href", "https://instagram.com/agrichecker", "target", "_blank", "rel", "noopener", 1, "nav-item", "nav-link"], ["src", "assets/img/instagram.icon.svg", 2, "height", "30px"], [1, "row", "mt-5"], [1, "align-self-center", "d-flex", "flex-wrap", "justify-content-around"], ["src", "assets/img/ozow.svg", 1, "my-1", "mx-2", 2, "height", "30px"], ["src", "assets/img/standard.svg", 1, "my-1", "mx-2", 2, "height", "30px"], ["src", "assets/img/absa.svg", 1, "my-1", "mx-2", 2, "height", "30px"], ["src", "assets/img/capitec.svg", 1, "my-1", "mx-2", 2, "height", "30px"], ["src", "assets/img/fnb.svg", 1, "my-1", "mx-2", 2, "height", "30px"], ["src", "assets/img/investec.svg", 1, "my-1", "mx-2", 2, "height", "30px"], ["src", "assets/img/nedbank.svg", 1, "my-1", "mx-2", 2, "height", "30px"], ["src", "assets/img/tyme.svg", 1, "my-1", "mx-2", 2, "height", "30px"], ["src", "assets/img/african.svg", 1, "my-1", "mx-2", 2, "height", "20px"], [1, "border-light"], [3, "routerLink"], [3, "href"]], template: function FooterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "footer", 0);
        ɵɵelementStart(1, "nav", 1);
        ɵɵelementStart(2, "div", 2);
        ɵɵelementStart(3, "div", 3);
        ɵɵelementStart(4, "div", 4);
        ɵɵelementStart(5, "div", 5);
        ɵɵelementStart(6, "div", 0);
        ɵɵtemplate(7, FooterComponent_div_7_Template, 3, 2, "div", 6);
        ɵɵtemplate(8, FooterComponent_ng_template_8_Template, 2, 2, "ng-template", null, 7, ɵɵtemplateRefExtractor);
        ɵɵelementEnd();
        ɵɵelementStart(10, "div", 0);
        ɵɵtemplate(11, FooterComponent_div_11_Template, 3, 2, "div", 6);
        ɵɵtemplate(12, FooterComponent_ng_template_12_Template, 2, 2, "ng-template", null, 8, ɵɵtemplateRefExtractor);
        ɵɵelementEnd();
        ɵɵelementStart(14, "div", 0);
        ɵɵelementStart(15, "a", 9);
        ɵɵtext(16);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(17, "div", 5);
        ɵɵelementStart(18, "div", 0);
        ɵɵtemplate(19, FooterComponent_div_19_Template, 3, 1, "div", 6);
        ɵɵelementEnd();
        ɵɵtemplate(20, FooterComponent_ng_template_20_Template, 2, 1, "ng-template", null, 10, ɵɵtemplateRefExtractor);
        ɵɵelementStart(22, "div", 0);
        ɵɵtemplate(23, FooterComponent_div_23_Template, 3, 2, "div", 6);
        ɵɵtemplate(24, FooterComponent_ng_template_24_Template, 2, 2, "ng-template", null, 11, ɵɵtemplateRefExtractor);
        ɵɵelementEnd();
        ɵɵelementStart(26, "div", 12);
        ɵɵelementStart(27, "a", 13);
        ɵɵelement(28, "img", 14);
        ɵɵelementEnd();
        ɵɵelementStart(29, "a", 15);
        ɵɵelement(30, "img", 16);
        ɵɵelementEnd();
        ɵɵelementStart(31, "a", 17);
        ɵɵelement(32, "img", 18);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(33, "div", 19);
        ɵɵelementStart(34, "div", 20);
        ɵɵelement(35, "img", 21);
        ɵɵelement(36, "img", 22);
        ɵɵelement(37, "img", 23);
        ɵɵelement(38, "img", 24);
        ɵɵelement(39, "img", 25);
        ɵɵelement(40, "img", 26);
        ɵɵelement(41, "img", 27);
        ɵɵelement(42, "img", 28);
        ɵɵelement(43, "img", 29);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(44, "hr", 30);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = ɵɵreference(9);
        const _r4 = ɵɵreference(13);
        const _r7 = ɵɵreference(21);
        const _r10 = ɵɵreference(25);
        ɵɵadvance(7);
        ɵɵproperty("ngIf", ctx.links.what_is_agrichecker.external)("ngIfElse", _r1);
        ɵɵadvance(4);
        ɵɵproperty("ngIf", ctx.links.advertise.external)("ngIfElse", _r4);
        ɵɵadvance(4);
        ɵɵproperty("href", ctx.links.blog.url, ɵɵsanitizeUrl);
        ɵɵadvance(1);
        ɵɵtextInterpolate(ctx.links.blog.title);
        ɵɵadvance(3);
        ɵɵproperty("ngIf", ctx.links.contact_us.external)("ngIfElse", _r7);
        ɵɵadvance(4);
        ɵɵproperty("ngIf", ctx.links.register.external)("ngIfElse", _r10);
    } }, directives: [NgIf, RouterLinkWithHref], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FooterComponent, [{
        type: Component,
        args: [{
                selector: 'acx-footer',
                templateUrl: './footer.component.html',
                styleUrls: ['./footer.component.scss']
            }]
    }], function () { return []; }, { links: [{
            type: Input
        }] }); })();

function OrderDetailsComponent_tr_19_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "tr");
    ɵɵelementStart(1, "td");
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementStart(3, "td");
    ɵɵtext(4);
    ɵɵelementEnd();
    ɵɵelementStart(5, "td");
    ɵɵtext(6);
    ɵɵelementEnd();
    ɵɵelementStart(7, "td");
    ɵɵtext(8);
    ɵɵpipe(9, "currency");
    ɵɵelementEnd();
    ɵɵelementStart(10, "td");
    ɵɵtext(11);
    ɵɵpipe(12, "currency");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ctx.$implicit;
    ɵɵadvance(2);
    ɵɵtextInterpolate(item_r2.name);
    ɵɵadvance(2);
    ɵɵtextInterpolate(item_r2.qty);
    ɵɵadvance(2);
    ɵɵtextInterpolate(item_r2.unit);
    ɵɵadvance(2);
    ɵɵtextInterpolate(ɵɵpipeBind4(9, 5, item_r2.price * item_r2.qty, "ZAR", "symbol-narrow", "1.2-2"));
    ɵɵadvance(3);
    ɵɵtextInterpolate(ɵɵpipeBind4(12, 10, item_r2.vat * item_r2.qty, "ZAR", "symbol-narrow", "1.2-2"));
} }
function OrderDetailsComponent_tr_20_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "tr");
    ɵɵelementStart(1, "td");
    ɵɵtext(2, "Delivery Fee");
    ɵɵelementEnd();
    ɵɵelement(3, "td");
    ɵɵelement(4, "td");
    ɵɵelementStart(5, "td");
    ɵɵtext(6);
    ɵɵpipe(7, "currency");
    ɵɵelementEnd();
    ɵɵelementStart(8, "td");
    ɵɵtext(9);
    ɵɵpipe(10, "currency");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(6);
    ɵɵtextInterpolate(ɵɵpipeBind4(7, 2, (ctx_r1.order == null ? null : ctx_r1.order.delivery_excl_vat) || 0, "ZAR", "symbol-narrow", "1.2-2"));
    ɵɵadvance(3);
    ɵɵtextInterpolate(ɵɵpipeBind4(10, 7, (ctx_r1.order == null ? null : ctx_r1.order.delivery_vat) || 0, "ZAR", "symbol-narrow", "1.2-2"));
} }
class OrderDetailsComponent {
    constructor() { }
    ngOnInit() { }
    get delivery_method() {
        return this.deliveryMethod === DeliveryMethod.Collection ? 'Collection' : 'Delivery';
    }
    get hasDeliveryFee() {
        return this.deliveryMethod === DeliveryMethod.Delivery;
    }
    get total() {
        return this.order ? +this.order.total : 0;
    }
    get total_vat() {
        return ((this.order && this.order.total_vat ? +this.order.total_vat : 0) +
            (this.order && this.order.delivery_vat ? +this.order.delivery_vat : 0));
    }
}
OrderDetailsComponent.ɵfac = function OrderDetailsComponent_Factory(t) { return new (t || OrderDetailsComponent)(); };
OrderDetailsComponent.ɵcmp = ɵɵdefineComponent({ type: OrderDetailsComponent, selectors: [["acx-order-details"]], inputs: { order: "order", deliveryMethod: "deliveryMethod" }, decls: 36, vars: 15, consts: [[1, "headings"], [1, "row"], [1, "col-md", 2, "overflow-x", "auto"], [1, "table-responsive"], [1, "table", "table-bordered", "order-table"], [4, "ngFor", "ngForOf"], [4, "ngIf"]], template: function OrderDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "h3", 0);
        ɵɵtext(1, "Order Details");
        ɵɵelementEnd();
        ɵɵelementStart(2, "div", 1);
        ɵɵelementStart(3, "div", 2);
        ɵɵelementStart(4, "div", 3);
        ɵɵelementStart(5, "table", 4);
        ɵɵelementStart(6, "thead");
        ɵɵelementStart(7, "tr");
        ɵɵelementStart(8, "th");
        ɵɵtext(9);
        ɵɵelementEnd();
        ɵɵelementStart(10, "th");
        ɵɵtext(11, "Qty");
        ɵɵelementEnd();
        ɵɵelementStart(12, "th");
        ɵɵtext(13, "Unit");
        ɵɵelementEnd();
        ɵɵelementStart(14, "th");
        ɵɵtext(15, "Subtotal (Excl. VAT)");
        ɵɵelementEnd();
        ɵɵelementStart(16, "th");
        ɵɵtext(17, "VAT");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(18, "tbody");
        ɵɵtemplate(19, OrderDetailsComponent_tr_19_Template, 13, 15, "tr", 5);
        ɵɵtemplate(20, OrderDetailsComponent_tr_20_Template, 11, 12, "tr", 6);
        ɵɵelementEnd();
        ɵɵelementStart(21, "tfoot");
        ɵɵelementStart(22, "tr");
        ɵɵelementStart(23, "td");
        ɵɵelementStart(24, "strong");
        ɵɵtext(25, "Total");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(26, "td");
        ɵɵelement(27, "td");
        ɵɵelementStart(28, "td");
        ɵɵelementStart(29, "strong");
        ɵɵtext(30);
        ɵɵpipe(31, "currency");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(32, "td");
        ɵɵelementStart(33, "strong");
        ɵɵtext(34);
        ɵɵpipe(35, "currency");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(9);
        ɵɵtextInterpolate1("Products for ", ctx.delivery_method, "");
        ɵɵadvance(10);
        ɵɵproperty("ngForOf", ctx.order == null ? null : ctx.order.items);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.hasDeliveryFee);
        ɵɵadvance(10);
        ɵɵtextInterpolate1("", ɵɵpipeBind4(31, 5, ctx.total, "ZAR", "symbol-narrow", "1.2-2"), " (Incl. VAT)");
        ɵɵadvance(4);
        ɵɵtextInterpolate(ɵɵpipeBind4(35, 10, ctx.total_vat, "ZAR", "symbol-narrow", "1.2-2"));
    } }, directives: [NgForOf, NgIf], pipes: [CurrencyPipe], styles: [".order-table[_ngcontent-%COMP%]{overflow:auto}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(OrderDetailsComponent, [{
        type: Component,
        args: [{
                selector: 'acx-order-details',
                templateUrl: './order-details.component.html',
                styleUrls: ['./order-details.component.scss']
            }]
    }], function () { return []; }, { order: [{
            type: Input
        }], deliveryMethod: [{
            type: Input
        }] }); })();

function ProductAttributeComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "span");
    ɵɵelementStart(2, "a", 1);
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵproperty("href", ctx_r0.attribute.value, ɵɵsanitizeUrl);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r0.attribute.name, "");
} }
function ProductAttributeComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "span");
    ɵɵelementStart(2, "a", 1);
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵproperty("href", ctx_r1.attribute.value, ɵɵsanitizeUrl);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r1.attribute.name, "");
} }
function ProductAttributeComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "span");
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵtextInterpolate(ctx_r2.attribute);
} }
class ProductAttributeComponent {
    constructor() {
        this.isUrl = ProductUtil.isUrl;
        this.isFile = ProductUtil.isFile;
        this.isOther = ProductUtil.isOther;
    }
    ngOnInit() { }
}
ProductAttributeComponent.ɵfac = function ProductAttributeComponent_Factory(t) { return new (t || ProductAttributeComponent)(); };
ProductAttributeComponent.ɵcmp = ɵɵdefineComponent({ type: ProductAttributeComponent, selectors: [["acx-product-attribute"]], inputs: { attribute: "attribute" }, decls: 3, vars: 3, consts: [[4, "ngIf"], ["target", "_blank", "rel", "noopener noreferrer", 3, "href"]], template: function ProductAttributeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, ProductAttributeComponent_div_0_Template, 4, 2, "div", 0);
        ɵɵtemplate(1, ProductAttributeComponent_div_1_Template, 4, 2, "div", 0);
        ɵɵtemplate(2, ProductAttributeComponent_div_2_Template, 3, 1, "div", 0);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.isUrl(ctx.attribute));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.isFile(ctx.attribute));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.isOther(ctx.attribute));
    } }, directives: [NgIf], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ProductAttributeComponent, [{
        type: Component,
        args: [{
                selector: 'acx-product-attribute',
                templateUrl: './product-attribute.component.html',
                styleUrls: ['./product-attribute.component.scss']
            }]
    }], function () { return []; }, { attribute: [{
            type: Input
        }] }); })();

class ConfirmDialogComponent {
    constructor(activeModal) {
        this.activeModal = activeModal;
    }
    ngOnInit() { }
    continue() {
        this.activeModal.close(true);
    }
    cancel() {
        this.activeModal.close(false);
    }
    dismiss() {
        this.activeModal.dismiss();
    }
}
ConfirmDialogComponent.ɵfac = function ConfirmDialogComponent_Factory(t) { return new (t || ConfirmDialogComponent)(ɵɵdirectiveInject(NgbActiveModal)); };
ConfirmDialogComponent.ɵcmp = ɵɵdefineComponent({ type: ConfirmDialogComponent, selectors: [["acx-confirm-dialog"]], inputs: { title: "title", message: "message", cancelText: "cancelText", continueText: "continueText" }, decls: 14, vars: 4, consts: [[1, "modal-header"], [1, "modal-title"], ["type", "button", "aria-label", "Close", 1, "close", 3, "click"], ["aria-hidden", "true"], [1, "modal-body"], [1, "modal-footer"], ["type", "button", 1, "btn", "btn-outline-dark", 3, "click"], ["type", "button", "ngbAutofocus", "", 1, "btn", "btn-outline-dark", 3, "click"]], template: function ConfirmDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "h4", 1);
        ɵɵtext(2);
        ɵɵelementEnd();
        ɵɵelementStart(3, "button", 2);
        ɵɵlistener("click", function ConfirmDialogComponent_Template_button_click_3_listener() { return ctx.dismiss(); });
        ɵɵelementStart(4, "span", 3);
        ɵɵtext(5, "\u00D7");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(6, "div", 4);
        ɵɵelementStart(7, "p");
        ɵɵtext(8);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(9, "div", 5);
        ɵɵelementStart(10, "button", 6);
        ɵɵlistener("click", function ConfirmDialogComponent_Template_button_click_10_listener() { return ctx.cancel(); });
        ɵɵtext(11);
        ɵɵelementEnd();
        ɵɵelementStart(12, "button", 7);
        ɵɵlistener("click", function ConfirmDialogComponent_Template_button_click_12_listener() { return ctx.continue(); });
        ɵɵtext(13);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(2);
        ɵɵtextInterpolate(ctx.title || "Are you sure?");
        ɵɵadvance(6);
        ɵɵtextInterpolate1(" ", ctx.message, " ");
        ɵɵadvance(3);
        ɵɵtextInterpolate(ctx.cancelText || "Cancel");
        ɵɵadvance(2);
        ɵɵtextInterpolate1(" ", ctx.continueText || "Continue", " ");
    } }, styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ConfirmDialogComponent, [{
        type: Component,
        args: [{
                selector: 'acx-confirm-dialog',
                templateUrl: './confirm-dialog.component.html',
                styleUrls: ['./confirm-dialog.component.scss']
            }]
    }], function () { return [{ type: NgbActiveModal }]; }, { title: [{
            type: Input
        }], message: [{
            type: Input
        }], cancelText: [{
            type: Input
        }], continueText: [{
            type: Input
        }] }); })();

function SnackbarComponent_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 5);
    ɵɵlistener("click", function SnackbarComponent_button_5_Template_button_click_0_listener() { ɵɵrestoreView(_r3); const ctx_r2 = ɵɵnextContext(); return ctx_r2.onAction(); });
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵproperty("color", ctx_r0.color);
    ɵɵadvance(1);
    ɵɵtextInterpolate(ctx_r0.action);
} }
function SnackbarComponent_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 6);
    ɵɵlistener("click", function SnackbarComponent_button_6_Template_button_click_0_listener() { ɵɵrestoreView(_r5); const ctx_r4 = ɵɵnextContext(); return ctx_r4.dismiss(); });
    ɵɵelementStart(1, "mat-icon");
    ɵɵtext(2, "close");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵproperty("color", ctx_r1.color);
} }
const defaultColors = {
    success: 'primary',
    info: 'accent',
    error: 'warn'
};
const defaultIcons = {
    success: 'check_circle',
    info: 'info',
    error: 'report'
};
class SnackbarComponent {
    constructor(snackbarRef, data) {
        this.snackbarRef = snackbarRef;
        this.data = data;
    }
    ngOnInit() { }
    get message() {
        return this.data ? this.data.message : '';
    }
    get action() {
        return this.data && this.data.action;
    }
    get icon() {
        if (!this.data)
            return null;
        const { type, icon } = this.data;
        if (icon)
            return icon;
        return defaultIcons[type] || null;
    }
    get color() {
        if (!this.data)
            return null;
        const { type } = this.data;
        return defaultColors[type] || null;
    }
    onAction() {
        this.snackbarRef.dismissWithAction();
    }
    dismiss() {
        this.snackbarRef.dismiss();
    }
}
SnackbarComponent.ɵfac = function SnackbarComponent_Factory(t) { return new (t || SnackbarComponent)(ɵɵdirectiveInject(MatSnackBarRef), ɵɵdirectiveInject(MAT_SNACK_BAR_DATA)); };
SnackbarComponent.ɵcmp = ɵɵdefineComponent({ type: SnackbarComponent, selectors: [["acx-snackbar"]], decls: 7, vars: 5, consts: [[1, "snackbar"], [3, "color"], [1, "message", "pl-3"], ["mat-button", "", 3, "color", "click", 4, "ngIf"], ["mat-icon-button", "", 3, "color", "click", 4, "ngIf"], ["mat-button", "", 3, "color", "click"], ["mat-icon-button", "", 3, "color", "click"]], template: function SnackbarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "mat-icon", 1);
        ɵɵtext(2);
        ɵɵelementEnd();
        ɵɵelementStart(3, "div", 2);
        ɵɵtext(4);
        ɵɵelementEnd();
        ɵɵtemplate(5, SnackbarComponent_button_5_Template, 2, 2, "button", 3);
        ɵɵtemplate(6, SnackbarComponent_button_6_Template, 3, 1, "button", 4);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("color", ctx.color);
        ɵɵadvance(1);
        ɵɵtextInterpolate(ctx.icon);
        ɵɵadvance(2);
        ɵɵtextInterpolate(ctx.message);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.action);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.action);
    } }, directives: [MatIcon, NgIf, MatButton], styles: [".snackbar[_ngcontent-%COMP%]{align-items:center;display:flex;justify-content:space-between}.snackbar[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{flex:1}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(SnackbarComponent, [{
        type: Component,
        args: [{
                selector: 'acx-snackbar',
                templateUrl: './snackbar.component.html',
                styleUrls: ['./snackbar.component.scss']
            }]
    }], function () { return [{ type: MatSnackBarRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_SNACK_BAR_DATA]
            }] }]; }, null); })();

class GooglePlacesDirective {
    constructor(mapsApiLoader, elRef) {
        this.mapsApiLoader = mapsApiLoader;
        this.elRef = elRef;
        this.select = new EventEmitter();
        this.element = elRef.nativeElement;
    }
    get isLoading() {
        return this._loading;
    }
    searchLocation(query = this.element.value) {
        if (!query || query.length < 3)
            return;
        this._loading = true;
        this.element.value = query;
        const $results = new Subject();
        this.placesService.findPlaceFromQuery({
            fields: ['name', 'geometry', 'place_id'],
            query
        }, results => {
            $results.next(results);
            $results.complete();
            this._loading = false;
        });
        return $results;
    }
    search(query = this.element.value) {
        if (!query || query.length < 3)
            return;
        this._loading = true;
        this.placesService.findPlaceFromQuery({
            fields: ['name', 'place_id'],
            query
        }, places => {
            if (places && places.length > 0)
                this.placesService.getDetails({ placeId: places[0].place_id }, placeDetails => {
                    this._loading = false;
                    this.select.emit(placeDetails);
                });
        });
    }
    ngOnInit() {
        this.mapsApiLoader.load().then(() => {
            this.placesService = new google.maps.places.PlacesService(this.element);
            const autocomplete = new google.maps.places.Autocomplete(this.element, {
                componentRestrictions: { country: 'ZA' }
            });
            this._googleMapsListener = google.maps.event.addListener(autocomplete, 'place_changed', () => {
                const place = autocomplete.getPlace();
                if (!place.address_components) {
                    this.search(place.name);
                    return;
                }
                this._loading = false;
                this.select.emit(place);
            });
        });
    }
    ngOnDestroy() {
        var _a;
        (_a = this._googleMapsListener) === null || _a === void 0 ? void 0 : _a.remove();
    }
}
GooglePlacesDirective.ɵfac = function GooglePlacesDirective_Factory(t) { return new (t || GooglePlacesDirective)(ɵɵdirectiveInject(MapsAPILoader), ɵɵdirectiveInject(ElementRef)); };
GooglePlacesDirective.ɵdir = ɵɵdefineDirective({ type: GooglePlacesDirective, selectors: [["", "acxGooglePlaces", ""]], outputs: { select: "select" }, exportAs: ["acxGooglePlaces"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(GooglePlacesDirective, [{
        type: Directive,
        args: [{
                selector: '[acxGooglePlaces]',
                exportAs: 'acxGooglePlaces'
            }]
    }], function () { return [{ type: MapsAPILoader }, { type: ElementRef }]; }, { select: [{
            type: Output
        }] }); })();

function BottomSheetComponent_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "a", 1);
    ɵɵlistener("click", function BottomSheetComponent_a_1_Template_a_click_0_listener($event) { ɵɵrestoreView(_r3); const item_r1 = ctx.$implicit; const ctx_r2 = ɵɵnextContext(); return ctx_r2.select($event, item_r1.id); });
    ɵɵelementStart(1, "span", 2);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementStart(3, "span", 2);
    ɵɵtext(4);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    ɵɵadvance(2);
    ɵɵtextInterpolate(item_r1.line_1);
    ɵɵadvance(2);
    ɵɵtextInterpolate(item_r1.line_2);
} }
class BottomSheetComponent {
    constructor(data, _bottomSheetRef) {
        this.data = data;
        this._bottomSheetRef = _bottomSheetRef;
    }
    ngOnInit() { }
    select($event, id) {
        this._bottomSheetRef.dismiss(id);
        $event.preventDefault();
    }
}
BottomSheetComponent.ɵfac = function BottomSheetComponent_Factory(t) { return new (t || BottomSheetComponent)(ɵɵdirectiveInject(MAT_BOTTOM_SHEET_DATA), ɵɵdirectiveInject(MatBottomSheetRef)); };
BottomSheetComponent.ɵcmp = ɵɵdefineComponent({ type: BottomSheetComponent, selectors: [["acx-bottom-sheet"]], decls: 2, vars: 1, consts: [["mat-list-item", "", 3, "click", 4, "ngFor", "ngForOf"], ["mat-list-item", "", 3, "click"], ["mat-line", ""]], template: function BottomSheetComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "mat-nav-list");
        ɵɵtemplate(1, BottomSheetComponent_a_1_Template, 5, 2, "a", 0);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("ngForOf", ctx.data.list);
    } }, directives: [MatNavList, NgForOf, MatListItem, MatLine], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(BottomSheetComponent, [{
        type: Component,
        args: [{
                selector: 'acx-bottom-sheet',
                templateUrl: './bottom-sheet.component.html',
                styleUrls: ['./bottom-sheet.component.scss']
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [MAT_BOTTOM_SHEET_DATA]
            }] }, { type: MatBottomSheetRef }]; }, null); })();

class CoreModule {
}
CoreModule.ɵmod = ɵɵdefineNgModule({ type: CoreModule });
CoreModule.ɵinj = ɵɵdefineInjector({ factory: function CoreModule_Factory(t) { return new (t || CoreModule)(); }, imports: [[
            RouterModule,
            CommonModule,
            MatIconModule,
            MatButtonModule,
            MatListModule,
            AgmCoreModule.forRoot({
                apiKey: 'AIzaSyA-1Ii54pEm-3N84LeNYnqWtoRd0THpOPw',
                libraries: ['places']
            })
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(CoreModule, { declarations: [FooterComponent,
        OrderDetailsComponent,
        ProductAttributeComponent,
        ConfirmDialogComponent,
        SnackbarComponent,
        GooglePlacesDirective,
        BottomSheetComponent], imports: [RouterModule,
        CommonModule,
        MatIconModule,
        MatButtonModule,
        MatListModule, AgmCoreModule], exports: [FooterComponent,
        OrderDetailsComponent,
        ProductAttributeComponent,
        ConfirmDialogComponent,
        SnackbarComponent,
        GooglePlacesDirective,
        BottomSheetComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(CoreModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    FooterComponent,
                    OrderDetailsComponent,
                    ProductAttributeComponent,
                    ConfirmDialogComponent,
                    SnackbarComponent,
                    GooglePlacesDirective,
                    BottomSheetComponent
                ],
                imports: [
                    RouterModule,
                    CommonModule,
                    MatIconModule,
                    MatButtonModule,
                    MatListModule,
                    AgmCoreModule.forRoot({
                        apiKey: 'AIzaSyA-1Ii54pEm-3N84LeNYnqWtoRd0THpOPw',
                        libraries: ['places']
                    })
                ],
                entryComponents: [ConfirmDialogComponent, SnackbarComponent, BottomSheetComponent],
                exports: [
                    FooterComponent,
                    OrderDetailsComponent,
                    ProductAttributeComponent,
                    ConfirmDialogComponent,
                    SnackbarComponent,
                    GooglePlacesDirective,
                    BottomSheetComponent
                ]
            }]
    }], null, null); })();

class NotificationService {
    constructor(snackbar) {
        this.snackbar = snackbar;
    }
    openSnackbar(config, onAction) {
        const _configWithDefaults = Object.assign({ duration: 10000, horizontalPosition: 'right', verticalPosition: 'bottom' }, config);
        const snackRef = this.snackbar.openFromComponent(SnackbarComponent, _configWithDefaults);
        snackRef.onAction().subscribe(onAction);
    }
}
NotificationService.ɵfac = function NotificationService_Factory(t) { return new (t || NotificationService)(ɵɵinject(MatSnackBar)); };
NotificationService.ɵprov = ɵɵdefineInjectable({ token: NotificationService, factory: NotificationService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(NotificationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: MatSnackBar }]; }, null); })();

class GeolocationService {
    constructor() { }
    getPosition() {
        const $results = new Subject();
        navigator.geolocation.getCurrentPosition(resp => {
            $results.next({ longitude: resp.coords.longitude, latitude: resp.coords.latitude });
            $results.complete();
        }, err => {
            $results.error(err);
        });
        return $results;
    }
}
GeolocationService.ɵfac = function GeolocationService_Factory(t) { return new (t || GeolocationService)(); };
GeolocationService.ɵprov = ɵɵdefineInjectable({ token: GeolocationService, factory: GeolocationService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(GeolocationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

/*
 * Public API Surface of core,
   intentionally left blank
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AccountStatus, Address, AddressFromGooglePlaceDetails, Alert, AlertType, ApiService, Bank, BottomSheetComponent, CanonicalDayOfWeek, CategoryDefinition, CityLookupService, CollectionLocation, CollectionLocationUtil, ConfirmDialogComponent, Context, CoreModule, DEFAULT_CATEGORY, DEFAULT_DELIVERY, DEFAULT_PRICE, DEFAULT_PRODUCT, DayOfWeek, DayTimeParser, DeliveryDetails, DeliveryFeeOption, DeliveryMethod, DeliveryRates, Dictionary, ERROR, Endpoints, FooterComponent, FormType, GeolocationService, GooglePlacesDirective, ImageService, ImageSize, NOTIFICATION, Namespace, NotificationService, OperatingHours, Optional, OrderDetailsComponent, OrderStatus, OrderSummary, PaymentMethods, ProductAttributeComponent, ProductCategories, ProductStatus, ProductSummary, ProductType, ProductUtil, Province, Roles, S3Uploader, SnackbarComponent, VAT, VatRate, contain, deliveryOverlap, distinct, flatMap, getDeliveryMethods, intersect, isBillingProfile, isDeliveryAddressProfile, isFileFieldType, isNumberFieldType, isProductAttribute, rateOverlap, shallowCompare };
//# sourceMappingURL=core.js.map
